import http, { getTenantFromUrl } from "../helpers/http";

export const changePassword = async (payload, tenant = getTenantFromUrl()) => {
  if (tenant) {
    return { success: true, message: "Password changed successfully (Mock)", data: {} };
  }
  const response = await http().post("/Account/ChangePassword", payload);
  return response.data;
};
